import { PatientNoteAiSummaryAvailableBanner } from '~/components/maud/patients/note/aiSummaryBanner/PatientNoteAiSummaryAvailableBanner';
import { GetAigssResponse } from '~/lib/types/notes/GetAigssResponse';
import { PatientNoteAiSummaryAwaitingBanner } from '~/components/maud/patients/note/aiSummaryBanner/PatientNoteAiSummaryAwaitingBanner';
import { PatientNoteAiSummaryErrorBanner } from '~/components/maud/patients/note/aiSummaryBanner/PatientNoteAiSummaryErrorBanner';
import { useEditPatientNoteFormContext } from '~/lib/contexts/EditPatientNoteFormContext';
import { EditNoteFormData } from '~/lib/types/notes/EditNoteFormData';
import { useFormikContext } from 'formik';
import { PatientNoteAiSummaryFeedbackBanner } from '~/components/maud/patients/note/aiSummaryBanner/PatientNoteAiSummaryFeedbackBanner';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { coalescePlainTextToEditorV2Html } from '@equip.health/ui';

type Props = {
  aigssSummary: GetAigssResponse;
  refreshAigss?: () => Promise<unknown>;
  isRefreshAigssFetching?: boolean;
};

// @deprecated remove when rich text session summary is live
const AIGSS_SEPARATOR_CONTENT = '\n\n\n-----------------------\n';
const HTML_AIGSS_SEPARATOR_CONTENT =
  '<p></p><p></p><p>-----------------------</p>';

export const PatientNoteAiSummaryBanner = ({
  aigssSummary,
  refreshAigss,
  isRefreshAigssFetching,
}: Props) => {
  const { sessionSummaryRichText: isSessionSummaryRichTextEnabled } =
    useFlags<LDFlags>();
  const { values: formValues } = useFormikContext<EditNoteFormData>();
  const { setFormField, sessionSummaryEditorRef } =
    useEditPatientNoteFormContext();

  if (!!formValues.aiSummaryId) {
    return <PatientNoteAiSummaryFeedbackBanner aigssSummary={aigssSummary} />;
  } else if (aigssSummary.status === null) {
    return (
      <PatientNoteAiSummaryAwaitingBanner
        isDisabled={isRefreshAigssFetching}
        onRefreshClick={refreshAigss}
      />
    );
  } else if (aigssSummary.status === 'SUCCESS') {
    return (
      <PatientNoteAiSummaryAvailableBanner
        onAddToNoteClick={() => {
          setFormField('aiSummaryId', aigssSummary.id);

          if (!isSessionSummaryRichTextEnabled) {
            const updatedSessionSummary = formValues.sessionSummary
              ? `${aigssSummary.text}${AIGSS_SEPARATOR_CONTENT}${formValues.sessionSummary}`
              : aigssSummary.text;

            setFormField('sessionSummary', updatedSessionSummary);
          } else {
            let textToInsert = coalescePlainTextToEditorV2Html(
              aigssSummary.text,
            );
            if (!sessionSummaryEditorRef.current.isEmpty) {
              textToInsert += HTML_AIGSS_SEPARATOR_CONTENT;
            }
            sessionSummaryEditorRef.current.commands.insertContentAt(
              0,
              textToInsert,
            );
          }
        }}
      />
    );
  } else if (aigssSummary.status === 'FAILURE') {
    return <PatientNoteAiSummaryErrorBanner />;
  }
  return <></>;
};
